import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Reactions, Threads, TimelineItem, TimelineItemType } from "@teammood/timeline";
import { MatTabsModule } from '@angular/material/tabs';
import { ReactionsComponent } from "../../reaction";
import { ThreadsComponent } from "../../../threads/threads.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { UserInfos } from "../../../../shared/ui/username-icon/user-infos.type";
import { ReviewBadgeComponent } from "../../review-badge/review-badge.component";
import { PollResultService } from "../poll-result.service";
import {
    ScalePollResultPyramidChartComponent
} from "./scale-question-result-pyramid-chart/scale-question-result-pyramid-chart.component";
import { PollResultCommentsComponent } from "../poll-result-comments/poll-result-comments.component";
import { PollResultValue, ScalePollResultTimelineItem } from "../poll-result.type";
import { CommonModule } from "@angular/common";
import { RecurringPollResultTrendsComponent } from "../recurring/recurring-poll-result-trends.component";
import { ManagerPanelComponent } from "../../manager-panel/manager-panel.component";

@Component({
    selector: "tm-scale-poll-result-card",
    templateUrl: "./scale-poll-result.component.html",
    styleUrls: ["./../poll-result.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatTabsModule,
        ScalePollResultPyramidChartComponent,
        ReactionsComponent,
        ThreadsComponent,
        TranslateModule,
        ReviewBadgeComponent,
        PollResultCommentsComponent,
        RecurringPollResultTrendsComponent,
        ManagerPanelComponent
    ]
})
export class ScalePollResultCardComponent implements OnInit{
    
    protected showTimelineItemOptions: boolean;
    protected tabIndexToShow: number = 0;
    protected showThreads: boolean = true;
    protected resultsTabLabel: string;
    protected trendsTabLabel: string;
    participationCount: number;
    totalParticipation: number = 0;
    orderedValues: PollResultValue[];

    @ViewChild('threadsComponent')
    private threadsComponent: ThreadsComponent;

    @Input() 
    pollResult: ScalePollResultTimelineItem;

    @Input() teamId: string;
    
    @Input() userInfos: UserInfos;

    @Input() isOdd: boolean;
    
    constructor(
        private translateService: TranslateService,
        private pollResultService: PollResultService
    ) {
        this.resultsTabLabel = this.translateService.instant('poll_results.results')
        this.trendsTabLabel = this.translateService.instant('poll_results.trends')
    }

    ngOnInit() {
        this.participationCount = this.pollResultService.getParticipationCount(this.pollResult.results.values)
        this.pollResult.results.values.forEach(item => this.totalParticipation += item.count)
        this.orderedValues = this.pollResult.results.values.sort((a, b) => b.position - a.position)
    }

    onTabChanged(event){
        this.tabIndexToShow = event.index;
    }

    protected toggleThreads() {
        this.showThreads = !this.showThreads;
    }
    protected discuss() {
        if (this.threadsComponent) {
            this.threadsComponent.discuss = true;
        }
    }

    protected onReacted(timelineItem: {id: string, itemType: TimelineItemType} & Reactions): void {
        if (timelineItem.itemType == "scaleQuestionResultItem"){
            this.pollResult = timelineItem as ScalePollResultTimelineItem;
        }
    }

    protected onThreadsUpdated(timelineItem: TimelineItem & Threads): void {
        if (timelineItem.itemType == "scaleQuestionResultItem"){
            this.pollResult = timelineItem as ScalePollResultTimelineItem;
        }
    }
}